export default __webpack_public_path__ + "static/mean-duration-chart-cb699ad7fa7d32b1aaee5ecd0172e706.svg";